const VOICE_CODES: any = [
    {
        code: 'hn_female_ngochuyen_full_48k-fhg',
        title: 'Bắc - Ngọc Huyền (Nữ - Tiếng Việt)',
    },
    {
        code: 'hn_male_phuthang_news65dt_44k-fhg',
        title: 'Bắc - Phú Thăng (Nam - Tiếng Việt)',
    },
    {
        code: 'hue_female_huonggiang_full_48k-fhg',
        title: 'Trung - Hương Giang (Nữ - Tiếng Việt)',
    },
    {
        code: 'hue_male_duyphuong_full_48k-fhg',
        title: 'Trung - Duy Phương (Nam - Tiếng Việt)',
    },

    {
        code: 'sg_female_lantrinh_vdts_48k-fhg',
        title: 'Nam - Lan Trinh (Nữ - Tiếng Việt)',
    },
    {
        code: 'sg_male_trungkien_vdts_48k-fhg',
        title: 'Nam - Trung Kiên (Nam - Tiếng Việt)',
    },
    {
        code: 'en-US-Standard-D',
        title: 'Tiếng Anh',
    }
];

export default VOICE_CODES;


// WEBPACK FOOTER //
// ./src/constants/VOICE_CODES.ts